
import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { createFakePlumbingBusiness } from '@/utils/firestore/fakeDataGenerator';
import { useToast } from '@/hooks/use-toast';
import { useNavigate } from 'react-router-dom';

const CreateFakeBusiness = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [result, setResult] = useState<{ businessId?: string; portfolioId?: string; message?: string } | null>(null);
  const { toast } = useToast();
  const navigate = useNavigate();

  const handleCreateBusiness = async () => {
    setIsLoading(true);
    try {
      const result = await createFakePlumbingBusiness();
      if (result.success) {
        setResult({
          businessId: result.businessId,
          portfolioId: result.portfolioId,
          message: result.message
        });
        
        toast({
          title: "Success!",
          description: "Created fake plumbing business with 50 leads",
          duration: 5000,
        });
      } else {
        toast({
          title: "Error",
          description: result.error || "Failed to create business",
          variant: "destructive",
          duration: 5000,
        });
      }
    } catch (error: any) {
      console.error("Error creating fake business:", error);
      toast({
        title: "Error",
        description: error.message || "An unexpected error occurred",
        variant: "destructive",
        duration: 5000,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const goToBusiness = () => {
    if (result?.businessId) {
      navigate(`/business/${result.businessId}`);
    }
  };

  return (
    <div className="bg-white rounded-lg border p-4 shadow-sm">
      <h3 className="text-lg font-medium mb-2">Create Fake Plumbing Business</h3>
      <p className="text-gray-600 mb-4">
        This will create a fake plumbing business with 50 leads spread over the last year and a $4,000 monthly budget.
      </p>
      
      <div className="flex flex-col gap-4">
        <Button 
          onClick={handleCreateBusiness} 
          disabled={isLoading}
          className="w-full"
        >
          {isLoading ? "Creating..." : "Create Fake Plumbing Business"}
        </Button>
        
        {result && (
          <div className="mt-4 bg-green-50 border border-green-200 p-3 rounded">
            <p className="text-green-800 mb-2">{result.message}</p>
            <p className="text-sm mb-2">Business ID: <code className="bg-green-100 px-1 rounded">{result.businessId}</code></p>
            <p className="text-sm mb-3">Portfolio ID: <code className="bg-green-100 px-1 rounded">{result.portfolioId}</code></p>
            
            <Button
              onClick={goToBusiness}
              variant="outline"
              className="mt-2 w-full"
            >
              Go to Business Dashboard
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default CreateFakeBusiness;
